module.exports = __webpack_public_path__ + "img/bamba_no.665c5c54.png";